import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  bannerWrapper: {
    marginHorizontal: scale(16),
    marginTop: scale(12),
  },
  container: {
    backgroundColor: colors.neutral.cotton,
    flex: 1,
  },
  content: {
    flex: 1,
    paddingBottom: scale(8),
  },
  filtersWrapper: {
    marginHorizontal: scale(16),
    marginTop: scale(8),
  },
  loaderContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  listWrapper: {
    flex: 1,
    marginHorizontal: scale(16),
    marginTop: scale(16),
  },
  emptyStateContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: scale(28),
  },
  emptyStateDescription: {
    marginTop: scale(8),
  },
  emptyStateImage: {
    height: scale(180),
    marginBottom: scale(28),
    width: scale(180),
  },
});

export default styles;
